import { useQuery } from '@tanstack/react-query';
import { getAiSupportedLanguages } from '../../services/api/implementation/impl';
import { AI_LANGUAGE_OPTIONS } from './AiLanguageSelect';

export function useAiTranslationLanguages() {
  const { data, isLoading } = useQuery({
    queryKey: ['aiTranslationLanguages'],
    queryFn: getAiSupportedLanguages,
    staleTime: 5 * 60 * 1000
  });

  const languages = data?.languages?.length ? data.languages : AI_LANGUAGE_OPTIONS;

  return { languages, isLoading };
}
